<template>
  <input ref="input" type="text" v-model="number" @blur="formatValue" @change="onChange"
         :readonly="readonly" class="input-number" :placeholder="placeholder">
</template>

<script>
  export default {
    name: 'input-number',
    props: {
      name: {
        type: String
      },
      readonly: {
        type: String
      },
      value: {
        default: ''
      },
      placeholder: {
        default: ''
      }
    },
    data: function () {
      return {
        number: 0
      }
    },
    watch: {
      value: function (val) {
        this.number = val
        this.$emit('input', this.parseNumber(this.number))
      },
      number: function (val) {
        this.formatValue()
      }
    },
    methods: {
      onChange: function () {
        this.$emit('input', this.parseNumber(this.number))
      },
      formatValue: function () {
        var number = this.parseNumber(this.number)

        var reg = /(^[+-]?\d+)(\d{3})/
        var n = (number + '')
        while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2')
        this.number = n
      },
      parseNumber: function (str) {
        var number = parseFloat(str.toString().replace(/,/g, ''))
        return isNaN(number) ? 0 : number
      }
    },
    mounted: function () {
      this.number = this.value
      this.formatValue()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ../common/components/InputNumber.vue